import { render, staticRenderFns } from "./en.vue?vue&type=template&id=2a7f557e&scoped=true"
import script from "./en.vue?vue&type=script&lang=js"
export * from "./en.vue?vue&type=script&lang=js"
import style0 from "./en.vue?vue&type=style&index=0&id=2a7f557e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7f557e",
  null
  
)

export default component.exports